import * as auth from './auth';
import * as firebase from './firebase';
import { firestore, storage } from './firebase';
const currentUser = () => {
    const { currentUser } = firebase.auth;
    return currentUser;
}

const userUid = () => {
    const { currentUser } = firebase.auth;
    if (!currentUser) {
        console.log('userUid vazio');
        return "";
    }
    return currentUser.uid;
}

const tokenBanco = () => {
    return userUid();
}

export {
    auth,
    userUid,
    tokenBanco,
    currentUser,
    firebase,
    storage,
    firestore,
};


// WEBPACK FOOTER //
// ./src/firebase/index.js